import React from 'react';
import { POPULAR_JOB_COUNTRIES } from 'constants/popularJobLinks';
import styles from '../Footer.module.scss';

const LocationJobs = () => {
  return (
    <ul className={styles.footerList}>
      <li className={styles.subTitle}>
        <a href="/jobs">
          <strong>Find Jobs by Location</strong>
        </a>
      </li>
      {POPULAR_JOB_COUNTRIES.map((country) => (
        <li key={country.slug}>
          <a href={`/jobs/in/${country.slug}`}>{country.footerLabel}</a>
        </li>
      ))}
      <li>
        <a href="/jobs/categories">All job categories</a>
      </li>
      <li>
        <a href="/jobs">Find Jobs Worldwide</a>
      </li>
    </ul>
  );
};

export default LocationJobs;
